import styled from 'styled-components';

export const IndexSection = styled.section`
  &:not(:last-child) {
    margin-bottom: 60px;
  }
`;

export const SectionHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
  
  a {
   color: inherit;
   
   transition: color 0.3s;
   
   &:hover {
    color: ${({ theme }) => theme.black};
   }
  }
  
  @media(min-width: 700px) {
    margin-bottom: 25px;
  }
`;

export const Heading = styled.h2`
  margin: 0;
  padding: 0;
  
  font-size: 20px;
  line-height: 25px;
  color: ${({ theme }) => theme.black};
  
  span {
    color: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 700px) {
    font-size: 24px;
    line-height: 30px;
  }
`;
